"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { grid } from './styles.js';

var _excluded = ["boxRef", "disablePadding"];
var GridContext = /*#__PURE__*/React.createContext({});
var Grid = function Grid(props) {
  var boxRef = props.boxRef,
    _props$disablePadding = props.disablePadding,
    disablePadding = _props$disablePadding === undefined ? false : _props$disablePadding,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useContext = React.useContext(GridContext),
    offsets = _React$useContext.offsets;
  return /*#__PURE__*/React.createElement(grid, _extends({
    "data-testid": "elemental-Grid",
    $offsets: offsets,
    ref: boxRef,
    $disablePadding: disablePadding
  }, rest));
};

export { Grid, GridContext };
